export default "__VITE_ASSET__5fdd7dfa__"